import { AnyAction, combineReducers, Reducer } from "redux";
import { reducer as formReducer } from "redux-form";
import { LOGOUT } from "../constants/auth";
import auth from "./auth";
import bidding from "./bidding";
import bookings from "./bookings";
import cities from "./cities";
import createBooking from "./create-booking";
import comments from "./comments";
import modals from "./modals";
import offices from "./offices";
import packages from "./packages";
import practices from "./practices";
import professions from "./professions";
import profile from "./profile";
import pwa from "./pwa";
import reports from "./reports";
import schedules from "./schedules";
import searchUser from "./search-user";
import selectDoctor from "./select-doctor";
import selectOffice from "./select-office";
import sendLink from "./send-link";
import specialties from "./specialties";
import ticket from "./ticket";
import tickets from "./tickets";
import timeslots from "./timeslots";
import wallet from "./wallet";
import setting from "./setting";
import algorithmExplanation from "./algorithm-explanation";
import officeManagement from "./office-management";
import editDurationInSchedule from "./edit-duration-schedule";
import notification from "./notification";
import profileImage from "./profile-image";

const reducers = {
  form: formReducer,
  auth,
  algorithmExplanation,
  bookings,
  bidding,
  createBooking,
  comments,
  offices,
  modals,
  schedules,
  practices,
  cities,
  specialties,
  packages,
  professions,
  profile,
  searchUser,
  sendLink,
  selectOffice,
  selectDoctor,
  timeslots,
  reports,
  tickets,
  ticket,
  setting,
  pwa,
  wallet,
  officeManagement,
  editDurationInSchedule,
  notification,
  profileImage,
};
type Reducers = typeof reducers;

export type State = {
  [Property in keyof Reducers]: ReturnType<Reducers[Property]>;
};

const appReducer = combineReducers<State>(reducers);
const rootReducer: Reducer<State, AnyAction> = (state, action) => {
  // Clear all data in redux store to initial.
  // @ts-ignore
  if (action.type === LOGOUT) state = {};

  return appReducer(state, action);
};

export default rootReducer;
